import * as React from "react";
import { SVGProps } from "react";

export const VerificationSuccessIllustration = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg fill="none" {...props}>
    <circle cx={66} cy={69} r={48} fill="#DEDFE0" opacity={0.2} />
    <path
      fill="#3E8D96"
      d="M15 57a3 3 0 0 1 3-3h96a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3V57Z"
    />
    <mask
      id="a"
      width={18}
      height={18}
      x={21}
      y={60}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M21 60h18v18H21V60Z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#F7F8F8"
        d="M30 76.502a7.302 7.302 0 0 1-2.924-.59 7.573 7.573 0 0 1-2.382-1.604 7.574 7.574 0 0 1-1.603-2.381 7.304 7.304 0 0 1-.59-2.925c0-1.037.196-2.012.59-2.925a7.575 7.575 0 0 1 1.603-2.381 7.573 7.573 0 0 1 2.382-1.603A7.302 7.302 0 0 1 30 61.502c1.038 0 2.013.197 2.925.59a7.573 7.573 0 0 1 2.382 1.604 7.575 7.575 0 0 1 1.603 2.381c.394.913.59 1.888.59 2.925a7.304 7.304 0 0 1-.59 2.925 7.575 7.575 0 0 1-1.603 2.381 7.573 7.573 0 0 1-2.382 1.603 7.302 7.302 0 0 1-2.924.591Z"
      />
    </g>
    <rect
      width={33}
      height={4.5}
      x={42}
      y={63}
      fill="#F7F8F8"
      opacity={0.9}
      rx={1.5}
    />
    <rect
      width={69}
      height={4.5}
      x={42}
      y={70.5}
      fill="#F7F8F8"
      opacity={0.6}
      rx={1.5}
    />
    <path
      fill="#AACFD3"
      d="M37.565 19.715c.431-1.418 2.438-1.418 2.87 0l2.532 8.32a1.5 1.5 0 0 0 .998.998l8.32 2.532c1.418.431 1.418 2.438 0 2.87l-8.32 2.532a1.5 1.5 0 0 0-.998.998l-2.532 8.32c-.432 1.418-2.439 1.418-2.87 0l-2.532-8.32a1.5 1.5 0 0 0-.999-.998l-8.32-2.532c-1.417-.432-1.417-2.439 0-2.87l8.32-2.532a1.5 1.5 0 0 0 .999-.999l2.532-8.32ZM91.565 97.715c.431-1.418 2.438-1.418 2.87 0l1.132 3.719a1.5 1.5 0 0 0 .998.999l3.72 1.132c1.418.431 1.418 2.438 0 2.87l-3.72 1.132c-.478.146-.852.52-.998.998l-1.132 3.72c-.432 1.418-2.439 1.418-2.87 0l-1.132-3.72a1.501 1.501 0 0 0-.999-.998l-3.72-1.132c-1.417-.432-1.417-2.439 0-2.87l3.72-1.132a1.5 1.5 0 0 0 .999-.999l1.132-3.72Z"
    />
    <mask
      id="b"
      width={31}
      height={31}
      x={88}
      y={16}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M88.5 16.5h30v30h-30z" />
    </mask>
    <g mask="url(#b)">
      <circle cx={103.484} cy={31.516} r={10.249} fill="#fff" />
      <path
        fill="#1F9E80"
        d="M101.53 33.662 99 31.1a1.42 1.42 0 0 0-1.01-.385c-.399 0-.746.134-1.04.4a1.447 1.447 0 0 0-.416 1.042c0 .405.15.726.448.96l3.523 3.556c.262.298.6.448 1.014.448.413 0 .769-.15 1.068-.448l7.271-7.27c.299-.274.448-.605.448-.994s-.148-.741-.443-1.057a1.503 1.503 0 0 0-1.061-.368c-.411.01-.753.144-1.026.4l-6.246 6.278ZM103.488 45c-1.853 0-3.605-.348-5.256-1.044a13.374 13.374 0 0 1-4.31-2.878 13.387 13.387 0 0 1-2.878-4.306A13.357 13.357 0 0 1 90 31.52c0-1.858.349-3.61 1.046-5.255a13.471 13.471 0 0 1 2.883-4.308 13.593 13.593 0 0 1 4.303-2.898A13.153 13.153 0 0 1 103.477 18c1.86 0 3.614.352 5.263 1.056a13.567 13.567 0 0 1 4.309 2.89 13.538 13.538 0 0 1 2.894 4.307c.705 1.647 1.057 3.403 1.057 5.266 0 1.861-.353 3.612-1.059 5.252a13.635 13.635 0 0 1-2.898 4.299 13.478 13.478 0 0 1-4.304 2.884c-1.642.697-3.392 1.046-5.251 1.046Z"
      />
    </g>
  </svg>
);
export default VerificationSuccessIllustration;
